export default __webpack_public_path__ + "static/horn_strobe_b.6beca5353182dc177c67ad992c1e1ce8.svg";